import { PaginationState } from '../../../../../interfaces/src/lib/types/index';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type QueryParams = {
  activePageIndex: string | null;
};

function parseQueryInit(): {
  activePageIndex: number;
} {
  const urlParams = new URLSearchParams(window.location.search);
  const queryParams: QueryParams = {
    activePageIndex: urlParams.get('page'),
  };

  const parseValues = (paramValue: string | null) => {
    if (!paramValue || isNaN(Number(paramValue)) || Number(paramValue) < 1) return 0;

    return Number(paramValue) - 1;
  };

  const activePageIndex: number = parseValues(queryParams.activePageIndex);

  return { activePageIndex };
}

const initialState: PaginationState = {
  activePageIndex: parseQueryInit().activePageIndex,
  hitsNumberPerPage: 0,
  paginationMode: 'numbered',
};

const pagination = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setPageIndexAndNumber: (
      state,
      action: PayloadAction<{ hitsNumberPerPage: number; activePageIndex: number }>
    ) => {
      state.hitsNumberPerPage = action.payload.hitsNumberPerPage;
      state.activePageIndex = action.payload.activePageIndex;
      return state;
    },
    setPaginationMode: (state, action: PayloadAction<{ paginationMode: string }>) => {
      state.paginationMode = action.payload.paginationMode;
      return state;
    },
  },
});

export const { setPageIndexAndNumber, setPaginationMode } = pagination.actions;
export default pagination.reducer;
